<ng-container *ngIf="isEnabled; else content">
  <ng-container *ngIf="disableTooltip || (isTooltipMode | async) === false; else tooltipContent">
    <div
      [class.fade-truncate]="isOverflowed | async"
      appTextOverflowCheck
      [appTextOverflowCheckDisabled]="!!tooltip || !isEnabled"
      (textOverflowed)="enableTooltipMode()">
      <ng-container *ngIf="customStyles; else noStyle">
        <div [ngStyle]="customStyles">
          <ng-container *ngIf="optionalTextPositionLeft">
            <span *ngIf="optionalText !== undefined && optionalText !== null" [ngStyle]="customOptionalStyles">
              {{ optionalText }}
            </span>
            {{ text }}
          </ng-container>
          <ng-container *ngIf="!optionalTextPositionLeft">
            {{ text }}
            <span *ngIf="optionalText !== undefined && optionalText !== null" [ngStyle]="customOptionalStyles">
              {{ optionalText }}
            </span>
          </ng-container>
        </div>
      </ng-container>

      <ng-template #noStyle>
        <ng-container *ngIf="optionalTextPositionLeft">
          <span *ngIf="optionalText !== undefined && optionalText !== null" [ngStyle]="customOptionalStyles">
            {{ optionalText }}
          </span>
          {{ text }}
        </ng-container>
        <ng-container *ngIf="!optionalTextPositionLeft">
          {{ text }}
          <span *ngIf="optionalText !== undefined && optionalText !== null" [ngStyle]="customOptionalStyles">
            {{ optionalText }}
          </span>
        </ng-container>
      </ng-template>
    </div>
  </ng-container>

  <ng-template #tooltipContent>
    <div
      [class.fade-truncate]="isOverflowed | async"
      [matTooltip]="
        (tooltipPrefix !== null && tooltipPrefix !== undefined ? tooltipPrefix + ': ' : '') + (tooltip ?? text)
      "
      [ngStyle]="customStyles">
      <ng-container *ngIf="optionalTextPositionLeft">
        <span *ngIf="optionalText !== undefined && optionalText !== null" [ngStyle]="customOptionalStyles">
          {{ optionalText }}
        </span>
        {{ text }}
      </ng-container>
      <ng-container *ngIf="!optionalTextPositionLeft">
        {{ text }}
        <span *ngIf="optionalText !== undefined && optionalText !== null" [ngStyle]="customOptionalStyles">
          {{ optionalText }}
        </span>
      </ng-container>
    </div>
  </ng-template>
</ng-container>

<ng-template #content>
  <ng-container *ngIf="optionalTextPositionLeft">
    <span *ngIf="optionalText !== undefined && optionalText !== null" [ngStyle]="customOptionalStyles">
      {{ optionalText }}
    </span>
    {{ text }}
  </ng-container>
  <ng-container *ngIf="!optionalTextPositionLeft">
    {{ text }}
    <span *ngIf="optionalText !== undefined && optionalText !== null" [ngStyle]="customOptionalStyles">
      {{ optionalText }}
    </span>
  </ng-container>
</ng-template>
